import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { ChartDataset, ChartType } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, OnChanges {
  @Input() public charType: ChartType;
  @Input() public data: any;
  @Input() public labels: string[] | any[];
  @Input() public colors: { backgroundColor?: string[]; borderColor?: string[] };
  @Input() public legend: boolean = false;
  @Input() public legendColorClasses = [];
  @Input() public legendTitle: string;
  @Input() public labelLegend: string = null;
  @Input() public options: any = {};
  public canvasDataset: ChartDataset[];

  public visible: boolean = false;

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    this.options = {
      ...this.options,
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: this.legend } }
    };
  }

  public ngOnChanges(): void {
    const add = (total: number, n: number) => total + n;
    this.visible = this.data && this.data.reduce(add, 0) > 0;

    if (this.visible) {
      this.setCanvasDataset();
    }
  }

  public totalSum(total: number, n: number) {
    return total + n;
  }

  /**
   * Set the dataset of chart
   * @private
   */
  private setCanvasDataset(): void {
    this.options = {
      ...this.options,
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: this.legend } }
    };
    this.canvasDataset = [
      {
        label: this.labelLegend ? this.translateService.instant(this.labelLegend) : null,
        data: this.data,
        backgroundColor: this.colors.backgroundColor,
        borderColor: this.colors.borderColor
      }
    ];
  }
}
